/* eslint-disable max-len */
/* eslint-disable jsx-a11y/no-autofocus */
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import Button from '../Button/Button';
import { 
  removeChartFromDashboardRequest
} from '../../store/dashboards/actions';

import * as styles from './RemoveChartModal.module.scss';

function RemoveChartModal({
  onClose,
  onSubmit,
  model,
  activeProject,
}) {
  const dispatch = useDispatch();

  const [submitting, setSubmitting] = useState(false);

  const sendDeleteRequest = () => {
      setSubmitting(true);
      dispatch(removeChartFromDashboardRequest({ ...model, projectId: activeProject?.id }, (success) => {
        if (success) {
          setSubmitting(false);
          onSubmit();
        } else {
          setSubmitting(false);
        }
      }));
  };

  return (
    <div className={styles.modal}>
      <div className={styles.modalContent}>
        <div className={styles.header}>
          <div className={styles.title}>Delete items</div>
        </div>
        <div className={styles.body}>
          <div className={styles.mainContent}>
            <div>
              <div>
                Chart
                {' '}
                <stong style={{ fontWeight: 700}}>{model.name}</stong>
                {' '}
                will be deleted completely, and cannot be restored. Are you sure?
              </div>
            </div>
          </div>
          <div className={styles.buttonGroup}>
              <Button style={{ width: 85 }} title="Cancel" type="secondary" onClick={onClose} />
              <Button
                style={{ width: 120, marginLeft: 12 }}
                type="red"
                title="Delete"
                disabled={submitting}
                onClick={() => {
                  sendDeleteRequest();
                }}
              />
          </div>
        </div>
      </div>
    </div>
  );
}

export default RemoveChartModal;
